import ApiResourceManager from '../ApiResourceManager';

// The platform agent itself (separate service, VITE_PLATFORM_AGENT_URL).
// Use with useApiClient({ baseUrl: import.meta.env.VITE_PLATFORM_AGENT_URL, autoLogOut: false }).
export default class PlatformAgentHealthManager extends ApiResourceManager {
  // eve's health check: `{ ok: true, status: 'ready' }` while the agent can take a chat.
  get = () =>
    this.request({
      method: 'GET',
      url: '/eve/v1/health',
    });
}
